import { useEffect, useState } from "react";

export default function useScroll() {
   const [scroll, setScroll] = useState(0);

   const scrollHandler = () => {
      const winScroll = window.scrollY || document.documentElement.scrollTop;
      const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const scrolled = (winScroll / height) * 100;
      setScroll(Math.floor(scrolled));
   };

   useEffect(() => {
      // For desktop
      window.addEventListener("wheel", scrollHandler, { passive: true });
      // For mobile
      window.addEventListener("scroll", scrollHandler, { passive: true });

      return () => {
         window.removeEventListener("wheel", scrollHandler, { passive: true });
         window.removeEventListener("scroll", scrollHandler, { passive: true });
      };
   }, [scroll]);

   return { scroll, setScroll };
}
